import React from 'react'
import styled from 'styled-components'

const StyledTooltip = styled.span`
  position: relative;
  display: inline-block;
  border-bottom: 1px dashed red;

  .tooltiptext {
    visibility: hidden;
    width: 200px;
    background-color: white;
    color: #000;
    text-align: center;
    padding: 2px 0;
    border-radius: 2px;
    font-size: 2rem;

    position: absolute;
    z-index: 1;
  }
  
  &:hover .tooltiptext {
    visibility: visible
  }
`;

export const Tooltip = ({meaning, children}) => {
    return <StyledTooltip>{children} <span className="tooltiptext">{meaning}</span></StyledTooltip>
}


